export default {
  nav: {
    home: 'Home',
    products: 'Products',
    about: 'Brand Story',
    media: 'Media Center',
    buyNow: 'Shop Now'
  },
  footer: {
    company: 'Changjiang Lubricants',
    description: 'Committed to providing high-quality lubricant products and solutions to global customers',
    quickLinks: 'Quick Links',
    contactInfo: 'Contact Info',
    address: 'Address: PetroChina Tower',
    phone: 'Tel: 400-888-8888',
    email: 'Email: info@changjiang.com',
    copyright: '© 2024 Changjiang Lubricants. All Rights Reserved',
    scanQR: 'Scan to Follow'
  },
  home: {
    heroTitle: 'Changjiang Lubricants',
    heroSubtitle: 'Quality Creates Future',
    aboutTitle: 'About Us',
    brandIntro: 'Brand Introduction',
    productSelection: 'Product Selection',
    brandAdvantages: 'Brand Advantages',
    mediaCenter: 'Media Center',
    partners: 'Partners',
    readMore: 'Read More',
    exploreMore: 'Explore More'
  }
}
